import { Component } from '@angular/core';

@Component({
  selector: 'fgb-non-renewing',
  templateUrl: './non-renewing.component.html',
  styleUrl: './non-renewing.component.scss',
})
export class NonRenewingComponent {}
